import React, { useState, useEffect } from "react";
import { apiRequest } from "../api"; // Import the apiRequest method

const IntegrationModal = ({ integration, onClose, onSave }) => {
    const [name, setName] = useState("");
    const [requestUrl, setRequestUrl] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const [feedbackMessage, setFeedbackMessage] = useState(null); // Feedback state

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token"); // Retrieve token from local storage

    useEffect(() => {
        if (integration) {
            setName(integration.name);
            setRequestUrl(integration.request_url);
            setImageUrl(integration.image_url);
        } else {
            setName("");
            setRequestUrl("");
            setImageUrl("");
        }
    }, [integration]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            name: name,
            request_url: requestUrl,
            image_url: imageUrl,
        };

        const url = integration
            ? `${apiUrl}/integrations/${integration.id}`
            : `${apiUrl}/integrations`;
        const method = integration ? "PUT" : "POST";

        setIsLoading(true);
        setFeedbackMessage(null); // Clear previous feedback

        try {
            const response = await apiRequest(url, method, payload, token);
            console.log(
                `Integration ${integration ? "updated" : "created"} successfully:`,
                response
            );

            // Set success feedback message
            setFeedbackMessage(
                `Integration ${integration ? "updated" : "created"} successfully!`
            );

            // Delay before closing the modal to allow the user to see the message
            setTimeout(() => {
                onSave();
                onClose();
            }, 2000); // 2-second delay
        } catch (error) {
            console.error(
                `Error ${integration ? "updating" : "creating"} integration:`,
                error
            );
            setFeedbackMessage(
                `Failed to ${integration ? "update" : "create"} integration. Please try again.`
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                }}
            >
                <h4>{integration ? "Edit Integrations" : "Add New Integration"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Integration Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Request URL:</label>
                        <input
                            type="input"
                            className="form-control"
                            value={requestUrl}
                            onChange={(e) => setRequestUrl(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Image URL:</label>
                        <input
                            type="input"
                            className="form-control"
                            value={imageUrl}
                            onChange={(e) => setImageUrl(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : integration ? "Update" : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                    </div>
                    {feedbackMessage && (
                        <div
                            className={`alert mt-3 ${
                                feedbackMessage.includes("successfully")
                                    ? "alert-success"
                                    : "alert-danger"
                            }`}
                        >
                            {feedbackMessage}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default IntegrationModal;
